import { Link } from 'react-router-dom';
import { statsData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20abstract%20sports%20composition%20with%20flowing%20energy%20waves%20in%20warm%20crimson%20and%20deep%20gold%20tones%2C%20geometric%20patterns%20suggesting%20motion%20and%20speed%2C%20modern%20minimalist%20aesthetic%20with%20layered%20translucent%20shapes%2C%20stadium%20atmosphere%20rendered%20as%20artistic%20light%20streaks%2C%20dark%20elegant%20background%20with%20subtle%20texture%2C%20editorial%20quality%2C%20sophisticated%20and%20powerful%20visual%20impact&width=1800&height=900&seq=hero-main-2026&orientation=landscape"
          alt="开云体育在线 - 官方体育平台"
          title="开云体育在线 - 顶级体育竞技平台"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-[900px] mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-fire-line text-accent-500 text-xs"></i>
          </div>
          <span className="text-xs font-medium text-accent-500 whitespace-nowrap">官方正品体育平台</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
          顶级体育竞技
          <br />
          <span className="text-accent-500">尽在开云体育</span>
        </h1>

        <p className="text-sm md:text-base text-background-200/90 max-w-[600px] mx-auto mb-8 leading-relaxed">
          覆盖全球30+体育项目，实时赔率更新，安全快捷存取款
          <br />
          注册即送专属欢迎礼包，开启您的体育竞技之旅
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 bg-accent-500 text-background-950 font-semibold text-sm rounded-md hover:bg-accent-400 transition-all duration-200 whitespace-nowrap"
          >
            立即注册
          </Link>
          <Link
            to="/category/football"
            className="w-full sm:w-auto px-8 py-3 border border-background-50/30 text-background-50 font-medium text-sm rounded-md hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap"
          >
            查看赛事
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-12">
          {statsData.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">{stat.value}</div>
              <div className="text-xs text-background-300/80 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 flex items-center justify-center">
          <div className="w-px h-4 bg-background-50/40 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}